import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { MODULE_IDS } from "../../constants/enums";

const SignatureList = Loadable(
  lazy(() =>
    import("./SignatureList").then(({ SignatureList }) => ({
      default: SignatureList,
    }))
  )
);

export const signatureRoutes = [
  {
    path: `/signatures`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMUNICATION]}>
        <SignatureList />
      </AuthorizedRoute>
    ),
  },
];
